import React from 'react'

import { useChartTimeframePathWatch } from '../../use-chart-timeframe-path-watch'
import { QuotePortalContext } from '../Portal'

export type QuoteLinksContextType = ReturnType<typeof useChartTimeframePathWatch>

function getDefaultContextValue() {
  const urlObject = new URL(window.location.href)

  return {
    chartLayoutModel: null,
    location: urlObject,
  }
}

export const QuoteLinksContext = React.createContext<QuoteLinksContextType>(getDefaultContextValue())

export function QuoteLinksWrapper({ children }: React.PropsWithChildren<any>) {
  const { toggleStaticElement } = React.useContext(QuotePortalContext)
  const info = useChartTimeframePathWatch()

  React.useEffect(() => toggleStaticElement(), [toggleStaticElement])

  return <QuoteLinksContext.Provider value={info}>{children}</QuoteLinksContext.Provider>
}
